import { IJBPMAP } from '../../../models/IJBPPMAP'
import { EMPTY_MAP_PLACEHOLDER, PLANNING_BY_FY_FQ } from '../../config'

import { getMapValueStandard } from './getMapValueStandard'

export const isMapDataPresentStandard = (
  mapData: IJBPMAP[],
  fy: number,
  category: string,
  isUnits: boolean = false
): boolean => {
  let isDataPresent = false

  const quarters = [PLANNING_BY_FY_FQ, 1, 2, 3, 4]

  quarters.forEach((fq) => {
    const val = getMapValueStandard(mapData, fy, category, fq, isUnits)
    if (val !== EMPTY_MAP_PLACEHOLDER) {
      isDataPresent = true
    }
  })

  return isDataPresent
}
